import { createRoute, useEntityUrl } from 'framework/routing';
import { HANDBOOK_PATH } from 'domain/shared/core/sharedRouteConstants';

export const useHandbookRoute = () => {
  return createRoute({ listRoute: HANDBOOK_PATH });
};

export const useHandbookUrl = () => {
  return useEntityUrl({
    baseLink: HANDBOOK_PATH,
  });
};
